export type IconProps = {
  selected: boolean;
};

export const gray = '#C0C8D2';
export const red = '#F3AD92';
export const orange = '#F6C58E';
export const yellow = '#F9D990';
export const darkGray = '#596171';
export const white = '#FFFFFF';
